export const GLOSSARY_CATEGORIES_QUERY = `GlossaryCategories {
    glossaryCategories(sort: "seq_id:asc", pagination: { page: 1, pageSize: 100 }) {
        data {
            id
            attributes {
                name
                label
                full_name
                subtitle
                color
                seq_id
            }
        }
    }
}`;

export const GLOSSARY_ABBREVIATIONS_QUERY = `GlossaryAbbreviations {
    glossaryAbbreviations(pagination: { page: 1, pageSize: 100 }) {
        data {
            id
            attributes {
                short_form
                full_form
                program
            }
        }
    }
}`;

export const GLOSSARY_TERMS_QUERY = `GlossaryTerms {
    glossaryTerms(pagination: { page: 1, pageSize: 100 }) {
        data {
            id
            attributes {
                title
                definition
                program
                seq_id
            }
        }
    }
}`;
